import CommandStack from './CommandStack';

/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  commandStack: [ 'type', CommandStack ]
};
